/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (resources) => ({
    type: actions.RESOURCES_RECEIVE,
    payload: { resources },
});